import { useMutation } from "react-query";
import { MedicalExaminationService } from "@services/medical-examination.service";

export const useDownloadPeriodicMedicalExamsMutation = () => {
  return useMutation(MedicalExaminationService.downloadPeriodicExams);
};
